import type { ISystem, ISystemGroup } from '../types';

export function isSystem(g_OR_s: ISystemGroup | ISystem): g_OR_s is ISystem {
  // TODO: Confirm this is a good check for distiction
  return (g_OR_s as ISystem)?.invitationUserName !== undefined;
}
